<template>
	<div class="contentMainDiv">
		<div>
			<div>
				<div>タイトル</div>
				<div><input type="text" class="inputSendMail" v-model="mailTitle"></div>
			</div>
			<br>
			<div>
				<div>本文</div>
				<div><textarea class="inputAreaSendMail"  v-model="mailMessage"></textarea></div>
			</div>

			<input type="button" class="button" value="送信" @click="sendMail">
		</div>
		<br><br>
		<div>
			<span style="color:red;">{{message}}</span>
			<div>送信履歴</div>
		
			<div class="table" style="max-height:200px;width:610px;">
				<table>
					<thead>
						<tr>
							<th @click="sort('registdate')">送信日{{sortMarkers['registdate']}}</th>
							<th @click="sort('title')">タイトル{{sortMarkers['title']}}</th>
							<th @click="sort('status')">送信状況{{sortMarkers['status']}}</th>
							<th @click="sort('progress')">送信進捗{{sortMarkers['progress']}}</th>
						</tr>
					</thead>
					<tbody>
						<tr  v-for="(data) in sendMailHistoryList" :key="data.id">
							<td class="tddate">{{ convertDateToDate( data.registdate ) }}</td>
							<td class="tdfilename">{{ data.title }}</td>
							<td>
								<a href="#"  @click.prevent.stop="viewMailHistoryById( data.id )" >{{ Definition.SEND_MAIL_STATUS[data.status] }}</a>
							</td>
							<td class="tdfilesize">{{ data.progress }}%</td>
						</tr>
					</tbody>
				</table>
			</div>
		
		</div>
		
			<div v-show="isDetailView" style="padding-top:20px;border: solid 2px;height:550px;width:700px;background:#fff;overflow: auto;position:absolute;  left:  600px; top: 100px;">
				<ViewMailHistory v-if="isDetailView==true" :id=viewId @setIsDetailView="setIsDetailView" @setMessage="setMessage" @changeStatus = "changeStatus" ref="viewMailHistoryComp" ></ViewMailHistory>
			</div>
		
	</div>
</template>


<script>
import { ref, onMounted, onUnmounted } from 'vue'
import * as Definition from "../api/Definition"
import SendMailRepository from "../composables/SendMailRepository"
import { convertDateToDate } from "../api/formatUtils";
import WatchActionProgress from "../composables/WatchActionProgress";

import ViewMailHistory from "../components/ViewMailHistory";
import listSort from '../composables/ListSort'


export default ({
  name: 'SendMail',
  components:{ViewMailHistory},
   setup(){
     const sendMailHistoryList = ref([])
     const mailTitle = ref("")
     const mailMessage = ref("")
     const message = ref("")
     const { getSendMailHistory, sendMailToUsers } = SendMailRepository()
     const isDetailView = ref(false)
     const viewId = ref("")
     const viewMailHistoryComp = ref( null )
     const sortMarkers = ref({registdate:'',title:'',status:'',progress:''})
     
     
     mailTitle.value = "カタログ更新のお知らせ"
     
     mailMessage.value = "$CompanyName$"
     mailMessage.value = mailMessage.value.concat("\n")
     mailMessage.value = mailMessage.value.concat("$Name$様")
     mailMessage.value = mailMessage.value.concat("\n\n")
     mailMessage.value = mailMessage.value.concat("平素よりお世話になっております。\n")
     mailMessage.value = mailMessage.value.concat("〇年●月のKOROKOROカタログを更新しましたのでお知らせいたします。\n")
     mailMessage.value = mailMessage.value.concat("弊社サイトよりダウンロードをお願いいたします。\n")
     mailMessage.value = mailMessage.value.concat("URL：https://koromaga.jp/")
     mailMessage.value = mailMessage.value.concat("\n\n")
     mailMessage.value = mailMessage.value.concat("商品サンプル動画は下記URLより視聴できます。\n")
     mailMessage.value = mailMessage.value.concat("※音声が流れますので音量にご注意ください。\n")
     mailMessage.value = mailMessage.value.concat("URL：")
     mailMessage.value = mailMessage.value.concat("\n\n")
     mailMessage.value = mailMessage.value.concat("商品リストならびに動画の元データ等のダウンロードは下記URLよりダウンロードいただけます。\n")
     mailMessage.value = mailMessage.value.concat("URL：")
     mailMessage.value = mailMessage.value.concat("\n\n")
     mailMessage.value = mailMessage.value.concat("ご不明点等ございましたら、担当営業にご連絡ください。")
     mailMessage.value = mailMessage.value.concat("\n\n")
     mailMessage.value = mailMessage.value.concat("※本メールアドレスは送信専用でございます。\n")
     mailMessage.value = mailMessage.value.concat("お問い合わせ0120-05-5951　サポート時間/10:00～17:00 (土日祝除く)")
     

    //ステータス変更、ViewSendMailHistoryコンポーネントから呼ばれる
    const changeStatus = (id, status) =>{
      sendMailHistoryList.value.find( s => s.id == id ).status = status
    }
     
    //データ取得時のコールバック
    const callback = ( result, data )=>{
      if( result != "success"){
        message.value = result
      }else{
        message.value = "データ取得完了"
        sendMailHistoryList.value = data
      }
    }
    
    //メール送信履歴データ取得
    getSendMailHistory( callback )
    
    //ソート用メソッド
    const { sort } = listSort( sendMailHistoryList, sortMarkers )
    
    //メール送信時のコールバック
    const callbackSendMail = ( result, data)=>{
      if( result != "ActionId"){
        message.value = data
      }else{
        message.value = "送信処理開始"
      }
    }
    
    //メール送信ボタン押下時
    const sendMail = () => {
      sendMailToUsers( mailTitle.value, mailMessage.value, callbackSendMail )
    }
    
    const viewMailHistoryById = ( id ) => {
      viewId.value = id

      console.log( id )
      viewId.value = id
      if(isDetailView.value) {
        isDetailView.value = false
      }else{
        isDetailView.value = true
      }
      
      console.log( isDetailView.value  )
      if( viewMailHistoryComp.value != null ){
        viewMailHistoryComp.value.$nextTick(() => {
          isDetailView.value = true
        })
      }
    }
    
    const setIsDetailView = ( value ) => {
      console.log( value )
      isDetailView.value = value
    }
    
   
   //Websocketを使用し、進捗状況を取得設定
   
    const callbackBatchUpdateProgress = ( result, errors, progressInfo, status, obj ) => {
      console.log( "callbackBatchUpdateProgress:" +result )
      console.log( obj )
      
      if( result == "NewItem"){
        sendMailHistoryList.value.unshift( obj )
        console.log( progressInfo )
      }else if( result == "ProgressList"){
        var infos = progressInfo.split(",")
        var percent = Math.floor( infos[2] / infos[1] * 100 )
        sendMailHistoryList.value.find( s => s.id == infos[0]).progress = percent
      }else if( result == "Status" ){
        console.log( progressInfo )
        infos = progressInfo.split(",")
        sendMailHistoryList.value.find( s => s.id == infos[0]).status = infos[1]
      }else if( status == "Progress" && result == "Close"){
        message.value = "接続が閉じられました。"
      }else if( status == "Error"){
        message.value = errors
      }

    }
   
   const { watchProgress, closeProgress } = WatchActionProgress( callbackBatchUpdateProgress )
   
    onMounted(()=>{
        watchProgress("SendMail")
    })
   
    onUnmounted(()=>{
        closeProgress()
    })
   
   
   //
   
   
    return{
      sendMailHistoryList,
      Definition,
      mailTitle,
      mailMessage,
      message,
      convertDateToDate,
      sendMail,
      isDetailView,
      viewId,
      viewMailHistoryComp,
      viewMailHistoryById,
      setIsDetailView,
      changeStatus,
      sort,
      sortMarkers
    }
   }
})
</script>